import { useEffect } from "react"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getReviewMarkForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getReviewMarkForSelect as getLotsForSelect } from '../../../actions/other/lotsActions'
import { getBooleanOptions } from "../../../constants/booleanOptions"
import { getResultOptions } from "../../../constants/resultOptions"
import { getTreatmentOptions } from "../../../constants/treatmentOptions"
import { getReviewMethods } from "../../../constants/reviewMethods"

export default function EventFormReview({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)
	const { lotsForSelect } = useSelector(state => state.lots)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
		dispatch(getLotsForSelect())
	}, [dispatch])

	const animals = animalsForSelect.map(a => ({ value: a._id, label: a.identifier }))
	const lots = lotsForSelect.map(l => ({ value: l._id, label: l.identifier }))

    const reviewMethods = getReviewMethods(t)
    const treatmentOptions = getTreatmentOptions(t)
    const resultOptions = getResultOptions(t)
    const booleanOptions = getBooleanOptions(t)

	const result = state.result

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_review')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.animals')}</Form.Label>
						<Select
							isMulti
							options={animals}
							value={animals.filter(opt => state.animals?.includes(opt.value))}
							onChange={opts => handleInputChange({ target: { name: 'animals', value: opts.map(o => o.value) } })}
							isClearable
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.animal.lots')}</Form.Label>
						<Select
							isMulti
							options={lots}
							value={lots.filter(opt => state.lots?.includes(opt.value))}
							onChange={opts => handleInputChange({ target: { name: 'lots', value: opts.map(o => o.value) } })}
							isClearable
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.method')}</Form.Label>
						<Select
							options={reviewMethods}
							value={reviewMethods.find(o => o.value === state.method) || null}
							onChange={opt => handleInputChange({ target: { name: 'method', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.result')}</Form.Label>
						<Select
							options={resultOptions}
							value={resultOptions.find(o => o.value === result) || null}
							onChange={opt => handleInputChange({ target: { name: 'result', value: opt.value } })}
						/>
					</Form.Group>
				</Col>
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.dateReview')}</Form.Label>
						<Form.Control
							type="date"
							name="dateReview"
							value={state.dateReview || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>

				{result === 'dudosa' && (
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.event.reviewQuestion')}</Form.Label>
							<Select
								options={booleanOptions}
								value={booleanOptions.find(o => o.value === state.review) || null}
								onChange={opt => handleInputChange({ target: { name: 'review', value: opt.value } })}
							/>
						</Form.Group>
					</Col>
				)}

				{result === 'tratamiento' && (
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.event.treatment')}</Form.Label>
							<Select
								options={treatmentOptions}
								value={treatmentOptions.find(o => o.value === state.treatment) || null}
								onChange={opt => handleInputChange({ target: { name: 'treatment', value: opt.value } })}
							/>
						</Form.Group>
					</Col>
				)}
			</Row>

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
